import { Component, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators, UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { CustomValidators } from '../../../app/custom-validators';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-login-br',
  templateUrl: './login-br.component.html',
  styleUrls: ['./login-br.component.scss']
})
export class LoginBrComponent {
loading = false;
  success = false;
  emailFormControl = new UntypedFormControl('', [
    Validators.required,
    //Validators.email,
    //CustomValidators.emailImanquehue
  ]);
  passwordFormControl = new UntypedFormControl('', [
    Validators.required
  ]);

  loginForm: UntypedFormGroup = new UntypedFormGroup({
    //email: this.emailFormControl,
    password: this.passwordFormControl
  });
  remember = false;
  passwordHide = true;
  matcher = new MyErrorStateMatcher();

  constructor(public authService: AuthService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    let email = "";
    let id = this.route.snapshot.queryParams.id;
    if(id && id!= null && id.length >0) {
      this.authService.id = id;
      email = atob(id);
      this.authService.id = email;
    }
    this.authService.pageAccess(email);
  }


  async onSubmit() {
    if (this.loading || this.loginForm.invalid) {
      return;
    }
    let email = "";
    if(this.authService.id) email= this.authService.id;
    this.loading = true;
    //let response = await this.authService.login(this.loginForm.value.email, this.loginForm.value.password);
    let response = await this.authService.login(email, this.loginForm.value.password);
    this.loading = false;
    if (response) {
      this.success = true;
    }
  }
}